import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React, { useCallback, useId } from 'react';
import I18n, { useI18n } from '../../../../i18n/I18n';
import { PROFILE_UPDATE_MODE_OPTIONS, PROFILE_UPDATE_MODE_TOKENS } from '../../../constants';
import type { ProfileUpdateMode, ProfileUpdateModeSelectProps } from '../../../types';

export default function ProfileUpdateModeSelect({
    value,
    onChange,
    options = PROFILE_UPDATE_MODE_OPTIONS,
    tokenOverrides
}: ProfileUpdateModeSelectProps) {
    const selectId = useId();
    const labelId = `${selectId}-label`;
    const t = useI18n();
    const label = t('shortlist.key.credits.ai.profile.update.label');

    const handleChange = useCallback(
        (event: SelectChangeEvent<ProfileUpdateMode>) => {
            onChange(event.target.value as ProfileUpdateMode);
        },
        [onChange]
    );

    return (
        <FormControl size="small" sx={{ minWidth: 220, width: '100%', mt: 1 }}>
            <InputLabel id={labelId}>{label}</InputLabel>
            <Select id={selectId} labelId={labelId} value={value} label={label} onChange={handleChange}>
                {options.map((mode) => (
                    <MenuItem key={mode} value={mode}>
                        <I18n token={tokenOverrides?.[mode] || PROFILE_UPDATE_MODE_TOKENS[mode]} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
